import React from 'react';
import ReactDOM from 'react-dom/client';
import posthog from 'posthog-js';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Initialize PostHog (session replay + analytics)
const posthogKey = process.env.REACT_APP_POSTHOG_KEY;
const posthogHost = process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';
if (posthogKey) {
  posthog.init(posthogKey, {
    api_host: posthogHost,
    session_recording: { enabled: true },
    person_profiles: 'identified_only',
    capture_pageview: true,
  });
} else if (typeof window !== 'undefined') {
  console.warn('[PostHog] Not configured: REACT_APP_POSTHOG_KEY was not set at build time. Analytics will not be sent.');
}

// Redirect from old domain to new domain (301 equivalent)
// This ensures users visiting old domains are redirected to new frameworkai.com.au domains
if (window.location.hostname === 'test.rewrite-ai.com.au') {
  const newUrl = 'https://test.frameworkai.com.au' + window.location.pathname + window.location.search + window.location.hash;
  window.location.replace(newUrl);
}
if (window.location.hostname === 'rewrite-ai.com.au') {
  const newUrl = 'https://frameworkai.com.au' + window.location.pathname + window.location.search + window.location.hash;
  window.location.replace(newUrl);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
